import left from './left.webp';
import right from './right.webp';

export const missionCardImages = [left, right];
